import { UrlUtils, wixServerData } from '@wix/package-picker-shared';
const getStudioAnonymousSignInRedirectionLink = locale => {
  const LOCALIZED_LOCALES = ['ja', 'fr', 'pt', 'de', 'es']; // TODO: Move to a constant, types

  const isLocalized = LOCALIZED_LOCALES.includes(locale);
  const baseUrl = isLocalized ? `//${locale}.wix.com/signin` : '//users.wix.com/signin';

  // TODO: Use const
  const postLoginUrl = isLocalized ? `https://${locale}.manage.wix.com/premium-pricing/studio` : 'https://www.manage.wix.com/premium-pricing/studio';
  const params = {
    studio: 'true',
    loginDialogContext: 'signup',
    postLogin: postLoginUrl,
    postSignUp: 'https://www.wix.com/intro/studio?ref=studio_signup'
  };
  return UrlUtils.buildUrl({
    url: baseUrl,
    params
  });
};
export const useAnonymous = () => {
  const {
    locale,
    userId
  } = wixServerData.get();
  const isAnonymous = !userId;
  const signInRedirectionLink = getStudioAnonymousSignInRedirectionLink(locale);
  return {
    isAnonymous,
    signInRedirectionLink
  };
};
//# sourceMappingURL=useAnonymous.js.map